"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getErrorCode;

var _get = _interopRequireDefault(require("lodash/get"));

var _isApiError = require("./is-api-error");

/**
 * If the payload represents and error from the Flow API, it will return the `code` for that error.
 * If the payload is an `order_builder` containing errors, the first error code in the list will be
 * returned.
 *
 * @param {Object} payload - The payload of an action
 */
function getErrorCode(payload) {
  if ((0, _isApiError.isOrderBuilderError)(payload)) {
    return (0, _get.default)(payload, 'errors[0].code');
  }

  return (0, _get.default)(payload, 'code');
}